export default __webpack_public_path__ + "static/media/toy5.b1a1bc8e.jfif";